import { useCallback, useEffect, useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Seo from "./Seo";
import HomeHero from "./home/HomeHero";
import HomeWhyChoose from "./home/HomeWhyChoose";
import HomeCreditScore from "./home/HomeCreditScore";
import HomeLoanDetails from "./home/HomeLoanDetails";
import HomeBenefits from "./home/HomeBenefits";
import HomeCalculator from "./home/HomeCalculator";
import HomeEligibility from "./home/HomeEligibility";
import HomeHowItWorks from "./home/HomeHowItWorks";
import HomeTrust from "./home/HomeTrust";
import HomeFaq from "./home/HomeFaq";
import HomeFinalCta from "./home/HomeFinalCta";
import HomeResources from "./home/HomeResources";
import HomePopup from "./home/HomePopup";

const HOME_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "FinancialService",
    name: "FastRupees",
    alternateName: ["Fast Rupees", "Fastrupee", "Fast Rupee", "FastRupe", "Fastrupees.com"],
    url: "https://fastrupees.com",
    logo: "https://fastrupees.com/fastrupeeslogo.png",
    description: "FastRupees offers instant, 100% digital payday and personal loans with zero paperwork and quick disbursal.",
    telephone: import.meta.env.VITE_COMPANY_PHONE,
    email: import.meta.env.VITE_COMPANY_EMAIL,
    address: {
      "@type": "PostalAddress",
      streetAddress: import.meta.env.VITE_COMPANY_ADDRESS,
      addressCountry: "IN",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "FastRupees",
    alternateName: ["Fast Rupees", "Fastrupee", "Fast Rupee", "FastRupe"],
    url: "https://fastrupees.com",
  },
];

function FastRupeesLanding() {
  // Opens 25s after every full page load of "/" (state resets on refresh); other routes never render it.
  const [showPopup, setShowPopup] = useState(false);
  const closePopup = useCallback(() => setShowPopup(false), []);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-w-screen overflow-x-hidden bg-white">
      <Seo
        title="Instant Personal Loans Online"
        description="Get instant payday and personal loans up to your eligibility with FastRupees — 100% digital, zero paperwork, fast approval and quick disbursal."
        path="/"
        schema={HOME_SCHEMA}
      />
      <Navbar />

      <main style={{ fontFamily: "'Outfit', sans-serif" }}>
        <HomeHero />
        <HomeWhyChoose />
        <HomeCreditScore />
        <div id="loan-details"><HomeLoanDetails /></div>
        <HomeBenefits />
        <div id="calculator"><HomeCalculator /></div>
        <div id="loan-eligibility"><HomeEligibility /></div>
        <div id="how-it-works"><HomeHowItWorks /></div>
        <HomeTrust />
        <div id="faq"><HomeFaq /></div>
        <HomeFinalCta />
        <HomeResources />
      </main>

      <Footer />

      {showPopup && <HomePopup onClose={closePopup} />}
    </div>
  );
}

export default FastRupeesLanding;
